import React from 'react';
import { Space as AntdSpace, SpaceProps } from 'antd';

const Space: React.FunctionComponent<SpaceProps> = props => {
	return <AntdSpace size="middle" {...props} />;
};

export default Space;
